import { LanguageCode } from 'enums';

export const DEFAULT_LANGUAGE = 'en_US';

export const MAP_LANGUAGE_TO_UPPY_LOCALE: Record<
  Partial<LanguageCode>,
  string
> = {
  [LanguageCode.English]: DEFAULT_LANGUAGE,
  [LanguageCode.Russian]: 'ru_RU',
  [LanguageCode.Spanish]: 'es_ES',
  [LanguageCode.Hindi]: 'hi_IN',
  [LanguageCode.Turkish]: 'tr_TR',
  [LanguageCode.Ukrainian]: 'uk_UA',
  [LanguageCode.Uzbek]: 'uz_UZ',
  [LanguageCode.Armenian]: 'hy_AM',
  [LanguageCode.Azerbaijani]: 'az_AZ',
  [LanguageCode.Kyrgyz]: 'ky_KG',
  [LanguageCode.Kazakh]: 'kk_KZ',
  [LanguageCode.Tajik]: 'tg_TJ',
};
